import { Button, Flex, Select } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormElementWrapper, { Options } from 'src/components/SelectElementWrapper';
import styled from 'styled-components';
import { AddOrEditUserModalForm, CPGORolSelection } from '../AddOrEditUserModal';
import { roles } from './cpGo';
import { useTranslation } from 'react-i18next';

interface ColorCardSettingsModalProps {
    shownDefaultCpGoRole: CPGORolSelection | undefined;
    alreadyPairedLicenseSystems: Array<Options> | undefined;
    allAvailableLicenseSystemOptions: Array<Options>;
    onCloseModal: () => void;
    onApplyButtonClick: () => void;
};

const ColorCardSettingsModal: FunctionComponent<ColorCardSettingsModalProps> = (props) => {

    const { control } = useFormContext<AddOrEditUserModalForm>();
    const { t } = useTranslation();

    return (
        <Flex width="100%" flexDirection="column" gap='40px'>
            <Controller
                control={control}
                name="colorCardAssignedLicenseSystems"
                render={({ field: { onChange, ref, value } }) => (
                    <FormElementWrapper label={t('ColorProofGoSettingsModal.input_select_license_system_combo', 'Select license system')} height="50px">
                        <Select
                            ref={ref}
                            width="100%"
                            placeholder={t('Common.combo_placeholder', 'Please select')}
                            name="License System Selector"
                            defaultValue={props.alreadyPairedLicenseSystems}
                            options={props.allAvailableLicenseSystemOptions}
                            onChange={onChange}
                            value={value}
                            isMulti
                            isSearchable
                            maxMenuHeight={140}
                        />
                    </FormElementWrapper>
                )}
            />

            {/* Note: Decided by Isabel that we are not showing the role for ColorCard settings, despite fact that it might change the effective role of CPGO permissions.
                <Controller
                control={control}
                name="cpGoRoleSelection"
                render={({ field: { onChange, ref, value } }) => (
                    <FormElementWrapper label={t('ColorProofGoSettingsModal.input_select_role_combo', 'ColorProof GO role')} height="50px">
                        <Select
                            ref={ref}
                            width="100%"
                            placeholder={t('Common.combo_placeholder', 'Please select')}
                            name="ColorProofGo Role Selector"
                            defaultValue={props.shownDefaultCpGoRole}
                            options={roles.map(role => ({ value: role, label: role }))}
                            onChange={onChange}
                            value={value}
                            isSearchable
                            isDisabled={true}
                        />
                    </FormElementWrapper>
                )}
            /> */}
            <ButtonContainer>
                <Button
                    variant="primary"
                    type="submit"
                    onClick={props.onApplyButtonClick}
                >
                    {t('ButtonTitles.action_apply_btn', 'Apply')}
                </Button>
                <Button
                    variant="secondary"
                    type="button"
                    onClick={props.onCloseModal}
                >
                    {t('ButtonTitles.action_cancel_btn', 'Cancel')}
                </Button>
            </ButtonContainer>
        </Flex>

    );
};

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    box-sizing: border-box;
    width: 100%;
    margin-top: 30px;
    & button {
        margin-left: 10px;
    }
`;

export default ColorCardSettingsModal;